

import { UPDATE_LOADER} from "./types";



export const upadteLoaderPopup = (boolean) => async dispatch => {
  dispatch({
    type: UPDATE_LOADER, 
    payload: boolean
  });
};





